import styled from 'styled-components';
import { DISABLE_BROWSER_AUTOFILL_SETTINGS } from '../../utils/disable-auto-complete';

/** @deprecated only here to facilitate @fox/data-grid & some other components in @fox/atoms. Use `{ Input } from 'foxd'`. This is basically just a copy of Input, but moving that from foxd to here would require significant extra effort  */
export const DeprecatedInput = styled.input`
	border: 1px solid ${props => props.theme.palette.swiftfox.neutral['50-midGrey']};
	border-radius: 3px;
	padding: 0.25em 0.5em;
	&::placeholder {
		font-weight: 300;
		color: ${props => props.theme.palette.grey[400]};
	}
	color: ${props => props.theme.palette.text.primary};
	font-size: 0.95rem;
	font-weight: 300;
	min-height: 40px;
	width: 100%;
	background-color: none;
	background: none;
	transition: all 0.3s ease-in-out;
	&:focus {
		outline: none;
		border: 1px solid ${props => props.theme.palette.primary.dark};
		transition: all 0.3s ease-in-out;
	}
	&:disabled {
		background-color: ${props => props.theme.palette.grey[200]};
		cursor: not-allowed;
	}
`;

DeprecatedInput.displayName = 'Input';
DeprecatedInput.defaultProps = {
	...DISABLE_BROWSER_AUTOFILL_SETTINGS
};
